<script setup lang="ts">
import type { DialogController } from "@/vf"

defineProps<{
    controller: DialogController<void>
    text: string
}>()
</script>

<template>
    <div class="dialog">
        <div class="dialog-body">
            <div class="mb-3" v-html="text" />
            <button type="button" class="btn btn-primary mt-3" @click="controller.ok()">Schließen</button>
        </div>
    </div>
</template>
